import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const MULTIBANCO: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Multibanco,
    name: 'multibanco',
    displayName: 'MULTIBANCO'
};
